(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fibes-proof-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (root.dataset.fpcInit) return;
      root.dataset.fpcInit = '1';

      var track = root.querySelector('[data-fpc-track]');
      var dotsWrap = root.querySelector('[data-fpc-dots]');
      var prevBtn = root.querySelector('[data-fpc-prev]');
      var nextBtn = root.querySelector('[data-fpc-next]');
      if (!track) return;

      // Lightbox lookup
      var sidMatch = (root.className.match(/fpc-([a-z0-9]+)/) || [])[1];
      var lightbox = sidMatch ? document.getElementById('fpc-lightbox-' + sidMatch) : null;
      if (!lightbox && root.parentNode) lightbox = root.parentNode.querySelector('[data-fpc-lightbox]');
      var stage = lightbox ? lightbox.querySelector('[data-fpc-stage]') : null;

      var originals = Array.prototype.slice.call(track.querySelectorAll('.fpc-item'));
      var n = originals.length;
      var unit = 0;        // item width + gap, in px
      var realStart = 0;   // scrollLeft of first real item
      var totalReal = 0;   // width of all real items
      var looping = false;

      function gapPx() {
        var g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
        return isNaN(g) ? 0 : g;
      }

      function clearClones() {
        track.querySelectorAll('[data-fpc-clone]').forEach(function (c) { c.remove(); });
      }

      function makeClone(item) {
        var c = item.cloneNode(true);
        c.setAttribute('data-fpc-clone', '1');
        c.removeAttribute('id');
        c.querySelectorAll('[data-fpc-tpl]').forEach(function (t) { t.remove(); });
        return c;
      }

      function build() {
        clearClones();
        if (n === 0) return;

        var first = originals[0];
        var gap = gapPx();
        unit = first.getBoundingClientRect().width + gap;
        var visible = unit > 0 ? Math.round((track.clientWidth + gap) / unit) : n;
        looping = n > visible;

        root.classList.toggle('fpc--static', !looping);

        if (looping) {
          var leadFrag = document.createDocumentFragment();
          var tailFrag = document.createDocumentFragment();
          originals.forEach(function (it) { tailFrag.appendChild(makeClone(it)); });
          originals.forEach(function (it) { leadFrag.appendChild(makeClone(it)); });
          track.appendChild(tailFrag);
          track.insertBefore(leadFrag, track.firstChild);

          totalReal = n * unit;
          realStart = n * unit;
          setScroll(realStart, false);
        }

        buildDots();
        updateDots();
      }

      function setScroll(x, smooth) {
        track.scrollTo({ left: x, behavior: smooth ? 'smooth' : 'auto' });
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        if (!looping && n <= 1) return;
        for (var i = 0; i < n; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'fpc-dot';
            d.setAttribute('aria-label', 'Go to item ' + (i + 1));
            d.addEventListener('click', function () { goTo(i); });
            dotsWrap.appendChild(d);
          })(i);
        }
      }

      function activeIndex() {
        if (unit === 0) return 0;
        var rel = looping ? (track.scrollLeft - realStart) : track.scrollLeft;
        var idx = Math.round(rel / unit);
        return ((idx % n) + n) % n;
      }

      function updateDots() {
        if (!dotsWrap) return;
        var active = activeIndex();
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === active ? 'true' : 'false');
        }
      }

      function goTo(i) {
        var base = looping ? realStart : 0;
        setScroll(base + i * unit, true);
      }

      function step(dir) {
        setScroll(track.scrollLeft + dir * unit, true);
      }

      function settle() {
        if (!looping || unit === 0) return;
        var x = track.scrollLeft;
        if (x < realStart - unit * 0.5) {
          setScroll(x + totalReal, false);
        } else if (x > realStart + totalReal - unit * 0.5) {
          setScroll(x - totalReal, false);
        }
      }

      var settleTimer;
      track.addEventListener('scroll', function () {
        updateDots();
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 130);
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      root.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-fpc-play]') : null;
        if (!btn || !stage) return;
        var tpl = document.getElementById(btn.getAttribute('data-fpc-target'));
        if (!tpl) return;
        stage.innerHTML = '';
        stage.appendChild(tpl.content.cloneNode(true));
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        var v = stage.querySelector('video');
        if (v) { try { v.play(); } catch (err) {} }
      });

      function closeLightbox() {
        if (!stage) return;
        var v = stage.querySelector('video');
        if (v) { try { v.pause(); } catch (err) {} }
        stage.innerHTML = '';
        lightbox.hidden = true;
        document.body.style.overflow = '';
      }
      if (lightbox) {
        lightbox.querySelectorAll('[data-fpc-close]').forEach(function (el) {
          el.addEventListener('click', closeLightbox);
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox();
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 200);
      });

      var firstImg = track.querySelector('img');
      if (firstImg && !firstImg.complete) {
        firstImg.addEventListener('load', build, { once: true });
        setTimeout(build, 500);
      } else {
        build();
      }
    }

    function boot() {
      document.querySelectorAll('[data-fpc-root]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = (e.target && e.target.querySelector) ? e.target.querySelector('[data-fpc-root]') : null;
      if (el) { delete el.dataset.fpcInit; initSection(el); } else { boot(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
